import Content from "@arelia-components/layout/Content";
import Header from "@arelia-components/layout/Header";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import { ConnectionName } from "@arelia-types/connection";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PATHS } from "src/routes";
import { MY_CONTENT_WIDGETS } from "./my-content-widgets";
import { Box } from "@mui/material";
import MenuSelector from "@arelia-components/ui-atoms/menu-selector/MenuSelector";
import { MenuType } from "@arelia-components/ui-atoms/menu-selector/models";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const ADD_SONGS_MENU_ITEMS = [{
  label: "Songtrust",
  value: "https://app.songtrust.com/songs/add/"
}, {
  label: "Distrokid",
  value: "https://distrokid.com/new/"
}, {
  label: "ASCAP",
  value: "https://www.ascap.com/member-access#works/online-work-registration"
}];

export default function MyContentContainer() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const navOptions = [
    { value: PATHS.MY_CONTENT_SONGS, label: "Songs" },
  ];

  const actionIcon = <AddOutlinedIcon color="error" />;
  const addSongsDropdown =
    <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2} flexGrow="1">
      <MenuSelector
        menuType={MenuType.contained}
        menuItems={ADD_SONGS_MENU_ITEMS}
        labelText={"Add New Song"}
        selectedValue={""}
        onClick={(url) => window.open(url, "_blank")}
        actionIcon={actionIcon}
      />
    </Box>

  useEffect(() => {
    if (pathname === PATHS.MY_CONTENT) {
      navigate(PATHS.MY_CONTENT_SONGS);
    }
  }, [pathname]);

  return (
    <ContentBox>
      <Header
        title="My Content"
        action={addSongsDropdown}
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />
      <Content requiredConnectionNames={[ConnectionName.songtrust, ConnectionName.distrokid, ConnectionName.ascap]} widgets={MY_CONTENT_WIDGETS} />
    </ContentBox>
  );
}